exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infos,\n.add-field-zone {\n  display: inline-block;\n  width: 32.66666%;\n  margin: 20px 0 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/exercise/exercise.component.scss
// module id = ../../../../../src/app/components/exercise/exercise.component.scss
// module chunks = main